import BidResume from '@/view/dashboard/bid-resume/BidResume'
import MainMenu from '@/components/foundation/main-menu/MainMenu'

export default {
  path: '/dashboard/bid-resume',
  name: 'BidResume',
  components: {
    default: BidResume,
    mainMenu: MainMenu
  },
  meta: {
    // auth: true,
    mainArea: 'dashboard',
    area: 'dashboard',
    breadcrumb: [
      { name: 'Relatório' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/dashboard/BidResume.js